<template>
  <li class="service-item">
    <div class="service-item__title flex items-center mb-3.5 md:mb-0">
      <div class="service-item__logo hidden lg:flex w-14 h-14 flex-shrink-0 mr-3.5">
        <img v-if="service.category_icon"
             :src="service.category_icon"
             class="max-h-full m-auto"/>
        <img v-else
             :src="require('images/icons/default_icon_service.svg')"
             class="max-h-full m-auto"/>
      </div>
      <p class="px-3 lg:px-0 text-base leading-4.5 font-semibold">{{ service.name }}</p>
    </div>
    <div class="max-w-max flex items-center lg:ml-4 bg-blue-190 rounded-xl">
      <div
          class="inline-flex items-center justify-center w-42 h-11.5 px-3 text-20/24 font-semibold lg:font-bold text-primary rounded-l-xl">
        {{ formatPrice(service.price, service.currency) }}
      </div>
      <a :href="`/services/${service.id}${categoryId? `?category_id=${categoryId}` : ''}`"
         class="px-8 z-1 button-md font-medium lg:font-semibold bg-white button-border-primary">
        Подробнее
      </a>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    service: {
      type: Object,
      default: null
    },
    categoryId: {
      type: Number,
      default: null
    },
  },

  methods: {
    formatPrice(val, currency) {
      const options = {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'symbol',
        minimumFractionDigits: 0,
      }
      return val.toLocaleString('ru-RU',  options)
    },
  }
}
</script>